import React, { createContext, useContext, useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import AddFeeScheduleDialog from './dialogs/AddFeeScheduleDialog'
import RemoveFeeScheduleDialog from './dialogs/RemoveFeeScheduleDialog'
import ReplaceFeeScheduleDialog from './dialogs/ReplaceFeeScheduleDialog'
import EditFamilyRateDialog from './dialogs/EditFamilyRateDialog'
import EditBillingStartDateDialog from './dialogs/EditBillingStartDateDialog'
import EditBillingAccountsDialog from './dialogs/EditBillingAccountsDialog'
import AddAccountOverrideDialog from './dialogs/AddAccountOverrideDialog'
import RemoveOverrideDialog from './dialogs/RemoveOverrideDialog'
import AddClassOverrideDialog from './dialogs/AddClassOverrideDialog'
import AddPositionOverrideDialog from './dialogs/AddPositionOverrideDialog'

export const ClientReviewContext = createContext({})

export function useClientReviewContext () {
  return useContext(ClientReviewContext)
}

function ClientReviewProvider ({ children, client, detail, clientsBaseQuery }) {
  const addFeeSchedule = useRef()
  const removeFeeSchedule = useRef()
  const replaceFeeSchedule = useRef()
  const editFamilyRate = useRef()
  const editBillingStartDate = useRef()
  const editBillingAccounts = useRef()
  const addAccountOverride = useRef()
  const addClassOverride = useRef()
  const addPositionOverride = useRef()
  const removeClientOverride = useRef()
  const value = useMemo(() => {
    return {
      client,
      detail,
      dialogs: {
        addFeeSchedule,
        removeFeeSchedule: (feeSchedule) => removeFeeSchedule.current.open(client, feeSchedule),
        replaceFeeSchedule: (feeSchedule) => replaceFeeSchedule.current.open(client, feeSchedule),
        editFamilyRate: (feeSchedule) => editFamilyRate.current.open(client, feeSchedule, clientsBaseQuery),
        editBillingStartDate: (account) => editBillingStartDate.current.open(account),
        editBillingAccounts: (account, billingAccounts) => editBillingAccounts.current.open(account, billingAccounts),
        addAccountOverride: () => addAccountOverride.current.open(client),
        addClassOverride: () => addClassOverride.current.open(client),
        addPositionOverride: () => addPositionOverride.current.open(client),
        removeClientOverride: (override, name) => removeClientOverride.current.open(client, override, name)
      }
    }
  }, [client, detail, clientsBaseQuery])

  return (
    <ClientReviewContext.Provider value={value}>
      {children}
      <AddFeeScheduleDialog ref={addFeeSchedule} />
      <RemoveFeeScheduleDialog ref={removeFeeSchedule} />
      <ReplaceFeeScheduleDialog ref={replaceFeeSchedule} />
      <EditFamilyRateDialog ref={editFamilyRate} />
      <EditBillingStartDateDialog ref={editBillingStartDate} />
      <EditBillingAccountsDialog ref={editBillingAccounts} />
      <AddAccountOverrideDialog ref={addAccountOverride} />
      <AddClassOverrideDialog ref={addClassOverride} />
      <AddPositionOverrideDialog ref={addPositionOverride} />
      <RemoveOverrideDialog ref={removeClientOverride} />
    </ClientReviewContext.Provider>
  )
}

ClientReviewProvider.propTypes = {
  children: PropTypes.node,
  client: PropTypes.object,
  detail: PropTypes.object,
  clientsBaseQuery: PropTypes.object
}

export default ClientReviewProvider
